/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */
export default function formatMuiErrorMessage(code) {
  var url = new URL("https://mui.com/production-error/?code=".concat(code));
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  args.forEach(function (arg) {
    return url.searchParams.append('args[]', arg);
  });
  return "Minified MUI error #".concat(code, "; visit ").concat(url, " for the full message.");
}